export default {"src":"/_next/static/media/user-icon.6b90a9b5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};